<template>
  <div class="consum-settings-panel">
    <setting-group
      v-if="erpSettingsGroup"
      :data="erpSettingsGroup"
      :visible-codes="consumVisibleCodes"
    />

    <div v-else class="placeholder-message">
      {{ $t("tools.erp_integration.erp_settings_group_not_found") }}
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import SettingGroup from "@/pages/tools/settings/partials/SettingGroup";

export default {
  name: "ErpConsumSettingsPanel",
  components: {
    SettingGroup,
  },
  data() {
    return {
      erpSettingsGroup: null,
      consumVisibleCodes: [
        "ERP_CONSUM_ENDPOINT",
        "ERP_CONSUM_COST_CENTER_SYMBOL",
        "ERP_CONSUM_CARNET_SYMBOL",
        "ERP_CONSUM_INVOICE_CARNET_SYMBOL",
        "ERP_CONSUM_INVOICE_SERVICE_ARTICLE_CODE",
        "ERP_CONSUM_INVOICE_SERVICE_ARTICLE_CODE_0",
        "ERP_CONSUM_INVOICE_SERVICE_ARTICLE_CODE_5",
        "ERP_CONSUM_INVOICE_SERVICE_ARTICLE_CODE_11",
        "ERP_CONSUM_CARNET_LIVR_SYMBOL",
        "ERP_CONSUM_NEXT_NR_DOC_IESIRE",
        "ERP_CONSUM_NEXT_NR_DOC_INTRARE",
        "ERP_CONSUM_RETRY_MAX_ATTEMPTS",
        "ERP_CONSUM_RETRY_BACKOFF_BASE_SECONDS",
      ],
    };
  },
  computed: {
    ...mapGetters({
      settingGroups: "settings/settingGroups",
    }),
  },
  methods: {
    ...mapActions({
      getGroups: "settings/getSettingGroups",
    }),
    resolveErpSettingsGroup() {
      const groups = this.settingGroups || [];

      const sourceGroup =
        groups.find((group) => {
          const code = (group?.code || "").toUpperCase();
          const itemCodes = (group?.items || []).map((item) => (item?.code || "").toUpperCase());

          return (
            code === "ERP_INTEGRATION" ||
            itemCodes.includes("ERP_INTEGRATION_ENABLED") ||
            itemCodes.includes("ERP_NAME")
          );
        }) || null;

      this.erpSettingsGroup = sourceGroup ? JSON.parse(JSON.stringify(sourceGroup)) : null;
    },
  },
  mounted() {
    this.getGroups().then(() => {
      this.resolveErpSettingsGroup();
    });
  },
  watch: {
    settingGroups: {
      handler() {
        this.resolveErpSettingsGroup();
      },
      deep: true,
    },
  },
};
</script>

<style lang="scss" scoped>
.consum-settings-panel {
  width: 100%;
}

.consum-settings-panel ::v-deep .setting-group-scroll.row {
  display: grid !important;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 16px;
  margin: 0;
}

.consum-settings-panel ::v-deep .setting-group-scroll > .setting {
  width: auto;
  max-width: 100%;
  padding: 0;
  margin: 0;
}

.consum-settings-panel ::v-deep .setting > .col-lg-10 {
  width: 100%;
  max-width: 100%;
  flex: 0 0 100%;
  padding: 0;
}

.consum-settings-panel ::v-deep .controls,
.consum-settings-panel ::v-deep .controls .col-lg-6 {
  width: 100%;
  max-width: 100%;
  flex: 0 0 100%;
}

.consum-settings-panel ::v-deep .setting-description {
  margin-left: 0 !important;
  padding-left: 0 !important;
}

.consum-settings-panel ::v-deep .setting-group-save {
  width: 100%;
  max-width: 180px;
  padding: 0;
  margin-top: 20px;
}

.placeholder-message {
  min-height: 120px;
  display: flex;
  align-items: center;
  color: #5f6b7a;
  font-size: 14px;
}

@media (max-width: 767.98px) {
  .consum-settings-panel ::v-deep .setting-group-scroll.row {
    grid-template-columns: minmax(0, 1fr);
  }
}
</style>
